<template>
    <div class="article-metadata">
        <NuxtImg
            :src="avatar"
            :alt="avatarAlt"
            width="40"
            height="40"
            fit="cover"
            format="auto"
            loading="lazy"
            class="article-metadata__image"
        />

        <div class="article-metadata__details">
            <p class="article-metadata__author k-text">
                By <NuxtLink :to="`/${slug}`">
                    {{ fullName }}
                </NuxtLink>
            </p>

            <p
                v-if="publicationDate"
                class="article-metadata__date k-text-xs"
            >
                <Icon name="tabler:calendar" />
                <time :datetime="publicationDate.datetime">
                    {{ publicationDate.label }}
                </time>
            </p>
        </div>
    </div>
</template>

<script setup>
import { DateTime } from 'luxon'
import { computed } from 'vue'

const props = defineProps({
    avatar: {
        type: String,
        required: true,
    },
    avatarAlt: {
        type: String,
        required: true,
    },
    fullName: {
        type: String,
        required: true,
    },
    slug: {
        type: String,
        required: true,
    },
    date: {
        type: String,
        default: '',
    },
})

const publicationDate = computed(() => {
    if (!props.date)
        return null

    const date = DateTime.fromISO(props.date)

    if (!date.isValid)
        return null

    return {
        datetime: date.toISO(),
        label: date.toFormat('cccc d LLLL yyyy'),
    }
})
</script>

<style lang="scss">
@use '@vemedia/karibu/styles/responsive' as *;

.article-metadata {
    display: flex;
    align-items: center;
    column-gap: var(--space-4);
    margin-block-end: var(--space-6);

    &__image {
        width: 40px;
        height: 40px;
        overflow: hidden;
        border-radius: var(--radius-full);
        object-fit: cover;
        object-position: center;
    }

    &__details {
        display: flex;
        flex: 1;
        flex-direction: column;
        gap: var(--space-2);

        @include tablet {
            flex-direction: row;
            align-items: flex-end;
            justify-content: space-between;
            gap: 0;
        }
    }

    &__author {
        font-weight: var(--font-weight-medium);

        a {
            color: inherit;

            &:hover,
            &:focus {
                text-decoration: underline;
            }
        }
    }

    &__date {
        display: flex;
        align-items: flex-start;
        gap: var(--space-2);
        font-weight: var(--font-weight-light);

        i,
        svg {
            font-size: var(--icon-size-1);
        }
    }
}
</style>
